import { useEffect } from 'react';

import { useCurrentUserQuery } from 'features/data/amplify/useCurrentUserQuery';
import { useGetUserQuery } from '../features/data/useGetUserQuery';

export function FreshchatDisplay() {
	const FRESHCHAT_TOKEN = process.env.REACT_APP_FRESHCHAT_TOKEN;
	const currentUserQuery = useCurrentUserQuery();
	const userQuery = useGetUserQuery();

	useEffect(() => {
		// every time user logs out, clear the chat
		if (!currentUserQuery.data) {
			const freshChat = window.fcWidget;
			if (freshChat && freshChat.user) {
				freshChat.user.clear();
			}
		}
	}, [currentUserQuery.data]);

	function initFreshChat() {
		const freshChat = window.fcWidget;
		const user = userQuery.data?.user;
		if (!freshChat || !user) return;

		freshChat.init({
			token: FRESHCHAT_TOKEN,
			host: 'https://ledidi.freshchat.com',
			widgetUuid: '64ddadcf-90a0-40f2-9a00-168d8bf730ee',
			// externalId ties the conversation to a known user; without it
			// Freshchat creates an anonymous contact and the chat shows as "Unknown".
			externalId: user.userid,
			firstName: user.userFirstName,
			lastName: user.userSirName,
			email: user.emailAddress
		});
	}

	function initialize() {
		const document = window.document;
		const elementId = 'Freshchat-js-sdk';

		const elem = document.getElementById(elementId);
		if (elem) {
			initFreshChat();
		} else {
			const e = document.createElement('script');
			e.id = elementId;
			e.async = !0;
			e.src = 'https://ledidi.freshchat.com/js/widget.js';
			e.onload = initFreshChat;
			document.head.appendChild(e);
		}
	}

	useEffect(() => {
		const freshChat = window.fcWidget;

		if (!userQuery.data) return;

		if (freshChat) {
			// initialize Freshchat only when on the help page
			if (!freshChat.isInitialized()) {
				initialize();
			}

			if (freshChat.isLoaded()) {
				freshChat.show();
			} else {
				freshChat.on('widget:loaded', () => {
					freshChat.show();
				});
			}
		}
	}, [userQuery.data]);

	return null;
}
